import React from 'react';
import { ErrorCodes } from '../constants/errorCodes';
import { EventLabelValues } from '../types/tracking';
import { InvitationErrorGeneric } from './InvitationErrors/InvitationErrorGeneric';
import { InvitationErrorIdentityAlreadyHasRole } from './InvitationErrors/InvitationErrorIdentityAlreadyHasRole';

interface InvitationErrorContentProps {
  errorCode: string | null;
}

export function InvitationErrorContent({ errorCode }: InvitationErrorContentProps) {
  switch (errorCode) {
    case ErrorCodes.IDENTITY_ALREADY_HAS_ROLE:
      return <InvitationErrorIdentityAlreadyHasRole />;
    case ErrorCodes.INVITE_EXPIRED:
      return <InvitationErrorGeneric trackingLabel={EventLabelValues.InvitationErrorInviteExpired} />;
    default:
      return <InvitationErrorGeneric />;
  }
}
